import { render } from "./Fa.vue?vue&type=template&id=3ccb7e85"
import script from "./Fa.vue?vue&type=script&lang=js"
export * from "./Fa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Content/Fa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ccb7e85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ccb7e85', __exports__)) {
    api.reload('3ccb7e85', __exports__)
  }
  
  module.hot.accept("./Fa.vue?vue&type=template&id=3ccb7e85", () => {
    api.rerender('3ccb7e85', render)
  })

}


export default __exports__